import { Typography } from '@mui/material'
import { Bin } from 'chezy-inventory-backend/bin/database/types/Bin'
import { useCallback, useMemo } from 'react'

import { InventoryBinRow } from './inventoryBinRow'
import { useInventoryContext } from './inventoryBrowserContext'
import { relevantSubtreeRecursiveSearch } from './utils'

export const InventoryOverview = () => {
  const { binTree, activeInventoryItems, activeInventoryMetadata } = useInventoryContext()

  // only show bins for which the inventory has items
  const relevantBins = useMemo(
    () =>
      relevantSubtreeRecursiveSearch(
        binTree,
        activeInventoryItems.map((i) => i.bin_id)
      ),
    [binTree, activeInventoryItems]
  )

  const getBinProgress = useCallback(
    (bin: Bin | undefined) => {
      let itemsInBin
      if (bin) {
        itemsInBin = activeInventoryItems.filter((item) => item.bin_id === bin.id)
      } else {
        itemsInBin = activeInventoryItems
      }

      return {
        scanned: itemsInBin.reduce((accumulator, item) => accumulator + (item.scanned_at ? 1 : 0), 0),
        total: itemsInBin.length,
        costScanned: itemsInBin
          .filter((i) => !!i.scanned_at)
          .map((i) => parseFloat(String(i.cost ?? 0)))
          .reduce((a, b) => a + b, 0),
        totalCost: itemsInBin.map((i) => parseFloat(String(i.cost ?? 0))).reduce((a, b) => a + b, 0),
      }
    },
    [activeInventoryItems]
  )

  const overallProgress = useMemo(() => getBinProgress(undefined), [getBinProgress])

  return (
    <div>
      <div>
        <Typography variant="h4">Inventory For: {activeInventoryMetadata?.name}</Typography>
        <Typography variant="subtitle1">
          {overallProgress.scanned} / {overallProgress.total} item(s) accounted for, $
          {overallProgress.totalCost - overallProgress.costScanned} missing
        </Typography>
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'auto auto minmax(50px, 1fr) auto',
          gap: 10,
          alignItems: 'center',
        }}
      >
        {relevantBins.map((bin) => (
          <InventoryBinRow key={bin.id} bin={bin} progressFn={getBinProgress} />
        ))}
      </div>
    </div>
  )
}
